<template>
  <div class="addHouse">
    <div class="header">
      <div class="title">房源新增</div>
      <div class="closeIcon" @click="close"></div>
    </div>
    <div class="content">
      <div class="part1">
        <div class="oneLine">
          <div>
            <div><span class="saleRent">售</span></div>
            <div>地址</div>
          </div>
          <div class="mgLeft">
            <div class="grey">楼盘</div>
            <input type="text" class="input_200 border" v-model="real_estate_name" @input="onRealNameInput"
              @blur="onRealNameBlur" @focus="onRealNameFocus">
          </div>
          <div>
            <div class="grey">幢座</div>
            <input type="text" class="input_200 border" v-model="build_num">
          </div>
          <div>
            <div class="grey">单元</div>
            <input type="text" class="input_100" v-model="unit">
          </div>
          <div>
            <div class="grey">房号</div>
            <input type="text" class="input_100 border" v-model="room_num">
          </div>
        </div>
        <div class="oneLine">
          <div>楼层</div>
          <input type="text" class="input_100 mgX border" v-model="floor">
          <div>户型</div>
          <input type="text" class="input_100 mgX border" v-model="room_count_shi">
          <div>室</div>
          <input type="text" class="input_100 mgX" v-model="room_count_ting">
          <div>厅</div>
          <input type="text" class="input_100 mgX" v-model="room_count_wei">
          <div>卫</div>
          <input type="text" class="input_100 mgX" v-model="room_count_yang">
          <div>阳台</div>
        </div>
        <div class="oneLine">
          <div>面积</div>
          <input type="text" class="input_100 mgX border" v-model="square">
          <div>m²</div>
          <div class="mgX">类型</div>
          <select v-model="build_type">
            <option value="住宅">住宅</option>
            <option value="商住">商住</option>
            <option value="商铺">商铺</option>
            <option value="写字楼">写字楼</option>
          </select>
          <div class="mgX">朝向</div>
          <select v-model="toward">
            <option value="东">东</option>
            <option value="南">南</option>
            <option value="西">西</option>
            <option value="北">北</option>
            <option value="南北">南北</option>
            <option value="东西">东西</option>
          </select>
          <div class="mgX">年代</div>
          <input type="text" class="input_100" v-model="year">
        </div>
        <div v-if="matchList.length>0" class="result-box">
          <div v-for="(item,index) in matchList" :key="item.id" @mousedown="chooseRealName(index)">
            {{item.real_estate_name}}</div>
        </div>
      </div>
      <div class="part2">
        <div class="oneLine">
          <div>来源</div>
          <input type="text" class="input_200 mgX border" v-model="from">
          <div>售价</div>
          <input type="text" class="input_150 mgX border" v-model="price" @input="toDanJia">
          <div>万元</div>
          <input type="text" class="input_150 mgX" v-model="price_dan" @input="toZongJia">
          <div>元/m²</div>
        </div>
        <div class="oneLine">
          <div>装修</div>
          <select class="mgLeft" v-model="decorate">
            <option value="毛坯">毛坯</option>
            <option value="清水">清水</option>
            <option value="简装">简装</option>
            <option value="精装">精装</option>
            <option value="豪装">豪装</option>
          </select>
          <select v-model="decorate_year">
            <option value="2019">2019</option>
            <option value="2018">2018</option>
            <option value="2017">2017</option>
            <option value="2016">2016</option>
            <option value="2015">2015</option>
            <option value="2014">2014</option>
            <option value="2013">2013</option>
            <option value="2012">2012</option>
            <option value="2011">2011</option>
            <option value="2010">2010</option>
            <option value="2009">2009</option>
            <option value="2008">2008</option>
            <option value="2007">2007</option>
            <option value="2006">2006</option>
          </select>
          <div class="mgX">现状</div>
          <select v-model="who_live">
            <option value="业主住">业主住</option>
            <option value="租客住">租客住</option>
            <option value="空置">空置</option>
          </select>
          <div class="mgX">动机</div>
          <input type="text" class="input_400 mgX" v-model="motive">
        </div>
      </div>
      <div class="part3">
        <div class="oneLine">
          <div>业主姓名</div>
          <input type="text" class="input_150 mgX border" v-model="name">
          <div>称谓</div>
          <select class="mgX" v-model="appellation">
            <option value="先生">先生</option>
            <option value="小姐">小姐</option>
            <option value="女士">女士</option>
          </select>
          <div>联系电话</div>
          <input type="text" class="input_200 mgX border" v-model="phone">
          <button class="check">查</button>
        </div>
        <div class="oneLine">
          <div>其它联系方式</div>
          <input type="text" class="input_200 mgX" v-model="other_way">
          <div>房东现状</div>
          <select class="mgX" v-model="stay">
            <option value="本地">本地</option>
            <option value="外地">外地</option>
            <option value="国外">国外</option>
          </select>
        </div>
      </div>
      <div class="part4">
        <button @click="save">保存</button>
        <button @click="close">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        realNameList: [],
        matchList: [],
        real_estate_name: '',
        real_estate_id: '',
        floor: '',
        unit: '',
        room_num: '',
        square: '',
        room_count_shi: '',
        room_count_ting: '',
        room_count_wei: '',
        room_count_yang: '',
        build_type: '',
        toward: '',
        year: '',
        price: '',
        price_dan: '',
        decorate: '',
        decorate_year: '',
        who_live: '',
        motive: '',
        name: '',
        appellation: '',
        phone: '',
        other_way: '',
        from: '',
        build_num: '',
        stay: '',

      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let that = this
        that.$axios.get(that.$url_prefix + 'queryOldRealNameList').then(function (res) {
          console.log('二手房楼盘名列表', res)
          that.realNameList = res.data.data
        }).catch(function (res) {
          console.log('获取楼盘名列表失败', res)
        })
      },

      //楼盘名 输入时 匹配楼盘名
      onRealNameInput() {
        let that = this
        let matchList = []
        for (let i in that.realNameList) {
          let name = that.realNameList[i].real_estate_name
          let flag = 0
          for (let i = 0; i < that.real_estate_name.length; i++) {
            if (name.indexOf(that.real_estate_name[i]) > -1) {
              flag++
            }
          }
          if (flag > 0) {
            that.realNameList[i].flag = flag
            matchList.push(that.realNameList[i])
          }
        }
        if (matchList.length > 0) {
          matchList.sort((a, b) => {
            return b.flag - a.flag
          })
          that.matchList = matchList
        } else {
          that.matchList = []
        }
      },
      //楼盘名输入框 失去焦点
      onRealNameBlur() {
        let that = this
        that.matchList = []
      },
      //楼盘名输入框 获得焦点
      onRealNameFocus() {
        let that = this
        let matchList = []
        for (let i in that.realNameList) {
          let name = that.realNameList[i].real_estate_name
          let flag = 0
          for (let i = 0; i < that.real_estate_name.length; i++) {
            if (name.indexOf(that.real_estate_name[i]) > -1) {
              flag++
            }
          }
          if (flag > 0) {
            that.realNameList[i].flag = flag
            matchList.push(that.realNameList[i])
          }
        }
        if (matchList.length > 0) {
          matchList.sort((a, b) => {
            return b.flag - a.flag
          })
          that.matchList = matchList
        } else {
          that.matchList = []
        }
      },
      //点选楼盘名
      chooseRealName(index) {
        let that = this
        that.real_estate_name = that.matchList[index].real_estate_name
        that.real_estate_id = that.matchList[index].id
        that.matchList = []
      },

      close() {
        this.$emit('childOper', {
          from: 'addHouse',
          oper: 'close'
        })
      },
      save() {
        let that = this
        if (!that.real_estate_id || !that.build_num || !that.room_num ||
          !that.floor || !that.room_count_shi || !that.square ||
          !that.from || !that.price || !that.name || !that.phone) {
          console.log('没有填完整')
          return
        }
        let obj = {
          real_estate_id: that.real_estate_id,
          build_num: that.build_num,
          unit: that.unit,
          room_num: that.room_num,
          floor: that.floor,
          square: that.square,
          build_type: that.build_type,
          toward: that.toward,
          year: that.year,
          from: that.from,
          price: that.price,
          who_live: that.who_live,
          motive: that.motive,
          name: that.name,
          appellation: that.appellation,
          phone: that.phone,
          other_way: that.other_way,
          stay: that.stay
        }
        let room_count = that.room_count_shi
        if (that.room_count_ting) {
          room_count += ('-' + that.room_count_ting)
        } else {
          room_count += '-0'
        }
        if (that.room_count_wei) {
          room_count += ('-' + that.room_count_wei)
        } else {
          room_count += '-0'
        }
        if (that.room_count_yang) {
          room_count += ('-' + that.room_count_yang)
        } else {
          room_count += '-0'
        }
        obj.room_count = room_count
        if (that.decorate) {
          if (that.decorate_year) {
            obj.decorate = that.decorate + '-' + that.decorate_year
          } else {
            obj.decorate = that.decorate
          }
        } else {
          obj.decorate = ''
        }
        let param = {
          'db': 'HouseModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('上传返回', res)
          that.$emit('childOper', {
            from: 'addHouse',
            oper: 'refresh'
          })
          that.close()
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

      toDanJia() {
        let that = this
        if (that.square) {
          that.price_dan = (parseInt(that.price) * 10000 /
            Number(that.square)).toFixed(2)
        }
      },
      toZongJia() {
        let that = this
        if (!that.price_dan) {
          that.price = ''
          return
        }
        that.price = (parseInt(that.price_dan) * Number(that.square) /
          10000).toFixed(2)
      }
    }
  }

</script>

<style scoped>
  input {
    outline: none;
  }

  .grey {
    color: grey;
  }

  .mgLeft {
    margin-left: 3px;
  }

  .mgX {
    margin: 0 3px;
  }

  select {
    padding: 1px 3px;
    outline: none;
    background-color: white;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -khtml-border-radius: 0;
    -webkit-appearance: none;
  }



  .addHouse {
    width: 500px;
    position: fixed;
    z-index: 5;
    box-shadow: 0px 0px 10px rgb(50, 50, 50);
    overflow: hidden;
    font-size: 15px;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-60%);
    background-color: white;
  }

  .header {
    background-color: skyblue;
    display: flex;
    padding: 8px;
    justify-content: space-between;
  }

  .title {
    font-weight: 500;
  }

  .closeIcon {
    width: 16px;
    height: 16px;
    background: url('../../static/images/close.png') 0 0 no-repeat;
  }

  .content {
    padding: 8px;
    line-height: 25px;
  }

  .part1 {
    position: relative;
  }

  .oneLine {
    display: flex;
    align-items: center;
  }

  .result-box {
    background-color: #fff;
    height: 200px;
    overflow-y: auto;
    position: absolute;
    z-index: 7;
    width: 220px;
    left: 0;
    top: 50px;
  }

  .saleRent {
    color: white;
    background-color: orange;
    padding: 3px;
    border-radius: 4px;
  }

  .part2 {
    padding: 10px 0;
    margin: 10px 0;
    border-top: 1px solid skyblue;
    border-bottom: 1px solid skyblue;
  }

  .check {
    background-color: orange;
    outline: none;
    padding: 2px;
  }

  .part4 {
    margin-top: 10px;
    border-top: 1px solid skyblue;
    text-align: center;
  }

  .part4 button {
    padding: 3px 10px;
    margin: 10px;
    border-radius: 5px;
    background-color: skyblue;
    outline: none;
  }


  .input_100 {
    width: 50px;
    height: 15px;
  }

  .input_150 {
    width: 75px;
    height: 15px;
  }

  .input_200 {
    width: 100px;
    height: 15px;
  }

  .input_400 {
    width: 200px;
    height: 15px;
  }

  .border {
    border: 1px solid orange;
    height: 17px;
  }

</style>



// WEBPACK FOOTER //
// src/components/AddHouse.vue